import React, {Component} from 'react';
import {Switch, Route, Redirect, Link} from 'react-router-dom';
import {
  Container,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Button
} from 'reactstrap';

import Notification  from 'react-web-notification';
/*
* Authentication
*/
import Alt from 'alt';
import history from '../../history';
import axios from 'axios';
import AuthActions from '../../actions/AuthActions';
import AuthStore from '../../stores/AuthStore';
import routes from '../../routes';
import {withRouter} from 'react-router-dom';

import Constants from '../../components/Constants/';

import Logout from '../../components/Logout/';
import Header from '../../components/Header/';
import Sidebar from '../../components/Sidebar/';
import Breadcrumb from '../../components/Breadcrumb/';
import Aside from '../../components/Aside/';
import AsideTwillio from '../../components/AsideTwillio/';
import Footer from '../../components/Footer/';


import Dashboard from '../../views/Dashboard/';
import ExamSearch from '../../views/ExamSearch';
import ExamSearchClient from '../../views/client/ExamSearchClient/';
import ExamForm from '../../views/client/ExamForm/';


import Antecedents from '../../views/admin/Antecedents/';
import Symptoms from '../../views/admin/Symptoms/';
import Diagnostics from '../../views/admin/Diagnostics/';
import Category from '../../views/admin/Category/';
import Speciality from '../../views/admin/Speciality/';

import ClientList from '../../views/admin/ClientList/';
import ClientForm from '../../views/admin/ClientForm/';

import DoctorList from '../../views/admin/DoctorList/';
import DoctorForm from '../../views/admin/DoctorForm/';

import GroupList from '../../views/admin/GroupList/';
import GroupForm from '../../views/admin/GroupForm/';

import ExamViewer from '../../views/ExamViewer/';
import ExamQueue from '../../views/Doctor/ExamQueue/';
import MyAccount from '../../views/Components/MyAccount/';


//Twilio
import $ from 'jquery';
import TwilioSDK from '../../components/twilio';
import twilioInstance from "../../twilioInstance.js";
import twilioChatClient from "../../twilioChatClient.js";
import TwilioChat from 'twilio-chat';
import {Launcher} from 'react-chat-window'

class Full extends Component {

constructor(props){
    super(props);
    let context = this;

    this.checkPendentExams = this.checkPendentExams.bind(this);
    this.showNotification = this.showNotification.bind(this);

    //twilio
    this.initTwilio = this.initTwilio.bind(this);
    this.initChat = this.initChat.bind(this);
    this.buildChannelsList = this.buildChannelsList.bind(this);

    this.call = this.call.bind(this);
    this.disconnect = this.disconnect.bind(this);

    this.answerCall = this.answerCall.bind(this);
    this.declineCall = this.declineCall.bind(this);

    this.addUserMessage = this.addUserMessage.bind(this);
    this.addResponseMessage = this.addResponseMessage.bind(this);
    this.handleNewUserMessage = this.handleNewUserMessage.bind(this);
    this.getOrCreateChannel = this.getOrCreateChannel.bind(this);
    this.openChatWindow = this.openChatWindow.bind(this);
    this.onMessageAddedInChannel = this.onMessageAddedInChannel.bind(this);

    function requireAuth() {
      if (AuthStore.getState().accessToken === null) {
        context.redirectToLogin();
      }

      if (AuthStore.getState().user === null) {
        context.redirectToLogin();
      }
    }

    this.state = {
      ignore: true,
      title: '',
      messageList: [],
      channelsList: [],
      activeChannel: {},
      isChatOpen: false,

      chatWindowTitle: "Ecardio",
      callInfo: null
    };

    //requireAuth();
    // Try to connect user from local storage value
    AuthActions.localLogin();


    document.body.classList.toggle('sidebar-minimized');
    // Handle API request errors
    axios.interceptors.response.use(
        response => {
            return response;
        }, error => {

            return new Promise((resolve, reject) => {
            if (error.status === 401 && error.data.error_description === 'The access token provided has expired.') {
                AuthActions.refreshToken({initialRequest: error.config, resolve: resolve, reject: reject});
            } else if (error.status === 401 && error.statusText === 'Unauthorized' && (error.response == undefined || (error.response != undefined && error.response.config.url.contains("oauth/token")))) {
            //} else if (error.status === 401 && error.statusText === 'Unauthorized') {
                AuthActions.logout();
                //context.redirectToLogin();
                window.location.reload();
            } else {
                reject(error);
            }
        });
    });

    /*
    * Inicia Twilio
    */

    this.initTwilio();
    this.initChat();
}

//TWILIO
initTwilio(){

  axios({
      method: 'get',
      url: Constants.apiUrl+'/api/v1/twiml/token'
  })
  .then(response => {
    // Setup Twilio.Device
    Twilio.Device.setup(response.data.token);

    twilioInstance.call = this.call;
    twilioInstance.disconnect = this.disconnect;

    twilioInstance.incoming = true;
    twilioInstance.isRinging = false;
    twilioInstance.isConnected = false;
    twilioInstance.connection = undefined;

    Twilio.Device.ready(function (device) {
      //log('Twilio.Device Ready!');
      //document.getElementById('call-controls').style.display = 'block';
    });

    Twilio.Device.error(function (error) {
      console.log('Twilio.Device Error: ' + error.message);

      twilioInstance.incoming = true;
      twilioInstance.isRinging = false;
      twilioInstance.isConnected = false;
      twilioInstance.connection = undefined;
      this.forceUpdate();
    }.bind(this));

    Twilio.Device.connect(function (conn) {
      //log('Successfully established call!');

      twilioInstance.isRinging = false;
      twilioInstance.isConnected = true;
      twilioInstance.connection = conn;

      this.forceUpdate();

    }.bind(this));

    Twilio.Device.disconnect(function (conn) {
      console.log('Call ended.');

      twilioInstance.incoming = true;
      twilioInstance.isRinging = false;
      twilioInstance.isConnected = false;
      twilioInstance.connection = undefined;
      this.forceUpdate();
    }.bind(this));

    Twilio.Device.cancel(function (conn) {
      console.log('Call ended.');

      twilioInstance.incoming = true;
      twilioInstance.isRinging = false;
      twilioInstance.isConnected = false;
      twilioInstance.connection = undefined;
      this.forceUpdate();
    }.bind(this));


    Twilio.Device.incoming(function (conn) {
      console.log(conn);
      console.log('Incoming connection from ' + conn.parameters.From);

      twilioInstance.incoming = true;
      twilioInstance.isRinging = true;
      twilioInstance.isConnected = false;
      twilioInstance.connection = conn;

      //Busca informações de cliente, exame, protocolo de atendimento pelo SID da Chamada
      axios({
          method: 'get',
          url: Constants.apiUrl+'/api/v1/twiml/parent/'+conn.parameters.CallSid
      })
      .then(response => {
          this.setState({
            "callInfo": response.data
          });
      });

      this.forceUpdate();

    }.bind(this));
  });
}

initChat(){

  axios({
      method: 'get',
      url: Constants.apiUrl+'/api/v1/twiml/chattoken'
  })
  .then(response => {
      TwilioChat.create(response.data.token).then(client => {

      twilioChatClient.client = client;
      twilioChatClient.getOrCreateChannel = this.getOrCreateChannel;

      this.buildChannelsList();

      /*Atualiza token do twilio quando expira*/
      let AccessManager = require('twilio-common').AccessManager;
      let accessManager = new AccessManager(response.data.token);
      accessManager.on('tokenExpired', () => {
        console.log("Token expired, refreshing.");
        axios({
            method: 'get',
            url: Constants.apiUrl+'/api/v1/twiml/chattoken'
        })
        .then(tokenResponse => {
          client.updateToken(tokenResponse.data.token);
        });
      });

      client.on('channelInvited', channel => {
        //Aceita convite automaticamente
        console.log("Convite para chat recebido.");
        channel.join().then(response => {
          channel.updateLastConsumedMessageIndex(0);
          channel.on('messageAdded', message => {
            this.onMessageAddedInChannel(channel, message);
          }, this);

          //Adiciona o Channel na lista de channels
          let channels = this.state.channelsList;
          channels.push(channel);
          this.setState({"channelsList": channels});
        });

      });

      client.on('channelRemoved', channel => {
        this.buildChannelsList();
      });

    }, this);
  });
}


addUserMessage(text) {
  if (text.length > 0) {
    this.setState({
      messageList: [...this.state.messageList, {
        author: "me",
        type: 'text',
        data: { text }
      }]
    })
  }
}

addResponseMessage(text, user) {
  if (text.length > 0) {
    this.setState({
      messageList: [...this.state.messageList, {
        author: "them",
        type: 'text',
        data: { text }
      }]
    });
  }
}

openChatWindow(){

  this.state.activeChannel.getMessages().then(messages => {
    this.setState({'messageList': [], 'isChatOpen': true, 'chatWindowTitle': "Exame "+this.state.activeChannel.friendlyName});

    let totalMessages = messages.items.length;

    for (let i = 0; i < totalMessages; i++) {
      const message = messages.items[i];

      if(message.author == AuthStore.getState().user.username){
        this.addUserMessage(message.body);
      }else{
        this.addResponseMessage(message.body, message.author);
      }
    }
  });
}

getOrCreateChannel(channelId, publicId){

  twilioChatClient.client.getChannelByUniqueName(channelId)
  .then(chosenChannel => {

    this.setState({"activeChannel": chosenChannel}, function(){
        this.openChatWindow();
        this.state.activeChannel.setAllMessagesConsumed();
    });
  }, this)
 .catch(err => {
   console.log(err);
    twilioChatClient.client.createChannel({
      uniqueName: channelId,
      friendlyName: publicId,
    })
    .then(createdChannel => {

      createdChannel.join().then(response => {
        //busca médicos que podem ver o exame e convida para o chat
        axios({
            method: 'get',
            url: Constants.apiUrl+'/api/v1/group/doctors/'+channelId
        })
        .then(response => {
          console.log(response);
          response.data.map(function(doctor, i){
            twilioChatClient.client.getUser(doctor.user.userName).then( user => {
              if(user){
                createdChannel.invite(doctor.user.userName).then(function() {
                  console.log('Your friend '+doctor.user.userName+' has been invited!');
                });
              }
            }).catch(err => {
              //Médico nunca se logou.
            });
          }, this);
        });

        createdChannel.on('messageAdded', message => {
          this.onMessageAddedInChannel(createdChannel, message);
        }, this);

        //Adiciona o Channel na lista de channels
        let channels = this.state.channelsList;
        channels.push(createdChannel);

        this.setState({"activeChannel": createdChannel, "channelsList": channels}, function(){
            this.openChatWindow();
            this.state.activeChannel.updateLastConsumedMessageIndex(0);
            this.state.activeChannel.setAllMessagesConsumed();
        });
      });
    });
  });
}

buildChannelsList(){
  let channels = [];

  //Pega a lista de Channels do usuário no Twilio
  twilioChatClient.client.getSubscribedChannels().then(paginator => {

    for (let i=0; i<paginator.items.length; i++) {
      let channel = paginator.items[i];

      //Pega todas as mensagens do Channel e a última mensagem
      channel.getMessages().then(messages => {
         let totalMessages = messages.items.length;

         if(totalMessages > 0){
           let message = messages.items[totalMessages-1];
          //  channel.lastMessage = message;
         }

         this.setState({"channelsList": channels});
       });

      channel.on('messageAdded',  message => {
        this.onMessageAddedInChannel(channel, message);
      }, this);
      channels.push(channel);
    }

    //this.setState({"channelsList": channels});
  });
}

onMessageAddedInChannel(channel, message){

  if(message.body == "#remove"){
    channel.delete();
  }

  if(this.state.activeChannel.uniqueName == channel.uniqueName){
    //Adiciona mensagem no Popup
    if(message.author == AuthStore.getState().user.username){
      this.addUserMessage(message.body);

    }else{
      this.addResponseMessage(message.body, message.author);
      this.playSound("new_message_sound");
      if(this.state.isChatOpen){
        channel.setAllMessagesConsumed().then( response => {
            //força atualização dos componentes
            //this.playSound("new_message_sound");
            this.setState({"channelsList": this.state.channelsList});
        });
      }
    }
  }

  channel.lastMessage = message;
  let letChannelsList = this.state.channelsList;
  this.state.channelsList.map((channelObj) =>{
    if(channelObj.uniqueName == channel.uniqueName){
      channelObj = channel;
    }
  });
  this.setState({"channelsList": letChannelsList});
}


handleNewUserMessage(newMessage){
  if(this.state.activeChannel){
    this.state.activeChannel.sendMessage(newMessage.data.text);
  }else{
    console.log("Nenhum channel encontrado");
  }
}

_handleClick() {
  this.setState({
   isChatOpen: !this.state.isChatOpen
  })
}

answerCall(){
  twilioInstance.connection.accept();

  twilioInstance.isRinging = false;
  twilioInstance.isConnected = true;

  console.log(twilioInstance.connection.parameters);
  console.log(twilioInstance.connection.options);
  this.forceUpdate();
}

declineCall(conn){
  twilioInstance.connection.reject();

  twilioInstance.incoming = true;
  twilioInstance.isRinging = false;
  twilioInstance.isConnected = false;
  twilioInstance.connection = undefined;
  this.forceUpdate();
}

call(number){
  if(number == undefined || number == null || number == ""){
    //this.showAlert("Este cliente não possui um telefone.");
    return false;
  }
  let params = {
    To: number
  };

  //this.showAlert("Chamando "+params.To);
  twilioInstance.incoming = false;
  twilioInstance.isRinging = true;
  twilioInstance.isConnected = false;
  twilioInstance.connection = undefined;

  Twilio.Device.connect(params);
  this.forceUpdate();
}

disconnect(){
  Twilio.Device.disconnectAll();

  twilioInstance.incoming = true;
  twilioInstance.isRinging = false;
  twilioInstance.isConnected = false;
  twilioInstance.connection = undefined;
  this.forceUpdate();
}

checkPendentExams(){
  //DESLIGA AS NOTIFICAÇÕES
  this.setState({
    ignore: Constants.ignoreNotifications
  });

  // Notificações de exames pendentes
  axios({
      method: 'get',
      url: Constants.apiUrl+'/api/v1/exam/doctor/count/'+AuthStore.getState().user.entity_id
  })
  .then(response => {
    if(! document.hasFocus()){
      if(response.data > 0) this.showNotification();
    }
  });

}

componentDidMount() {

  if(AuthStore.getState().user.profile == 'M')
    this.checkPendentExamsThread = setInterval(this.checkPendentExams, 30000);
}
componentWillUnmount() {
  if(AuthStore.getState().user.profile == 'M')
  clearInterval(this.checkPendentExamsThread);
}

redirectToLogin(){
    console.log("redirecting to login");
    history.replace("#/login");
    //this.props.history.push('/login');
}

//Permissions for notification API
handlePermissionGranted(){
  console.log('Permission Granted');
  this.setState({
    ignore: false
  });
}
handlePermissionDenied(){
  console.log('Permission Denied');
  this.setState({
    ignore: true
  });
}
handleNotSupported(){
  console.log('Web Notification not Supported');
  this.setState({
    ignore: true
  });
}

handleNotificationOnShow(e, tag){
  this.playSound('sound');
  //console.log(e, 'Notification shown tag:' + tag);
}

playSound(filename){
  document.getElementById(filename).play();
}

showNotification() {

    if(this.state.ignore) {
      return;
    }
    var now = new Date();
    const title = 'Exames Pendentes';
    const body = 'Atenção !! Há exames pendentes aguardando laudo.';
    const tag = "NON_REPORTED_EXAMS"+now;
    const icon = 'img/notification.png';

    // const icon = 'http://localhost:3000/Notifications_button_24.png';
    // Available options
    // See https://developer.mozilla.org/en-US/docs/Web/API/Notification/Notification
    const options = {
      tag: tag,
      body: body,
      icon: icon,
      lang: 'pt-br',
      sound: 'sound/sound.mp3'  // no browsers supported https://developer.mozilla.org/en/docs/Web/API/notification/sound#Browser_compatibility
    }
    this.setState({
      title: title,
      options: options
    });
  }


render() {
    return (
      <div className="app">
        <Header channelsList={this.state.channelsList} disconnect={this.disconnect} callInfo={this.state.callInfo}/>

        <div className="app-body">
          <Sidebar {...this.props}/>
          <main className="main container-flex">
            <Breadcrumb />
            <Container fluid className="flex-fill">
              <Switch>
                <Route path="/dashboard" name="Dashboard" component={Dashboard}/>
                <Route path="/myaccount" name="My MyAccount" component={MyAccount}/>
                //ADMIN
                <Route path="/antecedents" name="Antecedents" component={Antecedents}/>
                <Route path="/symptoms" name="Symptoms" component={Symptoms}/>
                <Route path="/category" name="Category" component={Category}/>
                <Route path="/speciality" name="Speciality" component={Speciality}/>
                <Route path="/diagnostics" name="Diagnostics" component={Diagnostics}/>
                <Route path="/clients" name="ClientList" component={ClientList}/>
                <Route path="/client/:clientId" name="ClientForm" component={ClientForm}/>
                <Route path="/client/" name="ClientForm" component={ClientForm}/>

                <Route path="/doctors" name="DoctorList" component={DoctorList}/>
                <Route path="/doctor/:doctorId" name="DoctorForm" component={DoctorForm}/>
                <Route path="/doctor/" name="DoctorForm" component={DoctorForm}/>

                <Route path="/groups" name="GroupList" component={GroupList}/>
                <Route path="/group/:groupId" name="GroupForm" component={GroupForm}/>
                <Route path="/group/" name="GroupForm" component={GroupForm}/>

                //CLIENT
                <Route path="/examSearchClient" name="Pesquisa Exames" component={ExamSearchClient}/>
                <Route path="/examForm" name="Upload de Exames" component={ExamForm}/>


                //DOCTOR
                <Route path="/examViewer/:examId" name="Exam Viewer" component={ExamViewer}/>
                <Route path="/examViewer" name="Exam Viewer" component={ExamViewer}/>
                <Route path="/examQueue" name="Exam Queue" component={ExamQueue}/>
                <Route path="/examSearch" name="Pesquisa de Exames" component={ExamSearch}/>
                <Redirect from="/" to="/dashboard"/>
              </Switch>
            </Container>
          </main>
          <AsideTwillio channelsList={this.state.channelsList}/>
        </div>
        <Footer />

        <Notification
          ignore={this.state.ignore && this.state.title !== ''}
          notSupported={this.handleNotSupported.bind(this)}
          onPermissionGranted={this.handlePermissionGranted.bind(this)}
          onPermissionDenied={this.handlePermissionDenied.bind(this)}
          onShow={this.handleNotificationOnShow.bind(this)}
          //onClick={this.handleNotificationOnClick.bind(this)}
          //onClose={this.handleNotificationOnClose.bind(this)}
          //onError={this.handleNotificationOnError.bind(this)}
          timeout={10000}
          title={this.state.title}
          options={this.state.options}
        />
        <audio id='sound' preload='auto'>
          <source src='sound/sound.mp3' type='audio/mpeg' />
          <source src='sound/sound.ogg' type='audio/ogg' />
          <embed hidden={true} loop={false} src='sound.mp3' />
        </audio>

        <audio id='new_message_sound' preload='auto'>
          <source src='sound/new_message_sound.mp3' type='audio/mpeg' />
          <embed hidden={true} loop={false} src='new_message_sound.mp3' />
        </audio>

        <Modal isOpen={((twilioInstance.isRinging) && twilioInstance.incoming)} className="info">
          <ModalHeader>Recebendo Chamada...</ModalHeader>
            <ModalBody>
              <div className={twilioInstance.isRinging && twilioInstance.incoming ? '' : 'hidden'}>
                Recebendo chamada de { this.state.callInfo ? this.state.callInfo.clientName : "" } {'\u00A0'}
                ({twilioInstance.connection ? twilioInstance.connection.parameters.From : "" })
                <br />
                <Link to={"/examViewer/"+(this.state.callInfo ? this.state.callInfo.examId : "000")}>Ver exame {this.state.callInfo ? this.state.callInfo.examPublicId : ""}</Link>

              </div>

              <div className={twilioInstance.isConnected && twilioInstance.incoming ? '' : 'hidden'}>
                Conversando com { this.state.callInfo ? this.state.callInfo.clientName : ""} {'\u00A0'}
                ({twilioInstance.connection ? twilioInstance.connection.parameters.From : ""})
                <br />

                <Link to={"/examViewer/"+(this.state.callInfo ? this.state.callInfo.examId : "000")}>Ver exame {this.state.callInfo ? this.state.callInfo.examPublicId : ""}</Link>

              </div>
            </ModalBody>

            <ModalFooter>
              <div className={twilioInstance.isRinging && twilioInstance.incoming ? '' : 'hidden'}>
                <Button color="success" onClick={this.answerCall}><i className="fa fa-phone"></i>{'\u00A0'} Atender </Button>
                <Button color="danger" onClick={this.declineCall}><i className="fa fa-phone"></i>{'\u00A0'} Rejeitar </Button>
              </div>

              <div className={twilioInstance.isConnected && twilioInstance.incoming ? '' : 'hidden'}>
                <Button color="danger" onClick={this.disconnect}><i className="fa fa-phone"></i>{'\u00A0'} Encerrar Chamada </Button>
              </div>
            </ModalFooter>
          </Modal>

          <Launcher
            agentProfile={{
              teamName: <Link className="text-white" to={"/examViewer/"+(this.state.activeChannel ? this.state.activeChannel.uniqueName : "000")}>{this.state.chatWindowTitle}</Link>,
              imageUrl: 'https://a.slack-edge.com/66f9/img/avatars-teams/ava_0001-34.png'
            }}
            onMessageWasSent={this.handleNewUserMessage}
            messageList={this.state.messageList}
            showEmoji={false}
            isOpen={this.state.isChatOpen}
            handleClick={this._handleClick.bind(this)}
          />

      </div>
    );
  }
}

export default Full;



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js